import React, { useRef, useState } from 'react';
import { Dialog, DialogActions, DialogTitle, Button } from "@mui/material";
import axios from 'axios';
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import CaseStatus from "../../enums/CaseStatus";
import CaseFilesInternal from "../../enums/CaseFilesInternal";
import CaseFilesStatus from "../../enums/CaseFilesStatus";
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";
import { IoDocument } from "react-icons/io5";
import { MdDeleteForever } from "react-icons/md";

function ChildrenCaseRegistration({ open, handleClose, caseData, onFileAdded }) {

    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const params = new URLSearchParams(window.location.search);
    const caseId = parseInt(params.get('id'), 10);
    const [file, setFile] = useState(null);
    const fileInputRef = useRef(null);

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = error => reject(error);
    });

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            if (selectedFile.type !== 'application/pdf') {
                setFile(null);
            } else {
                setFile(selectedFile);
            }
        }
    };

    const handleDeleteFile = () => {
        setFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = ''; // Reset the input value
        }
    };

    const handleViewDocument = () => {
        if (file) {
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank');
            URL.revokeObjectURL(fileURL);
        }
    };

    const sendNotification = async (caseId) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CreateCaseNotificationforHeadOfAgency`, {
                caseId: caseId,
                caseStatus: CaseStatus.Sent.id,
                action: CaseNotificationEnum.requestToChangeObject.id
            });

        } catch (error) {
        }
    };

    const handleSendData = async () => {
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/AddNewCase`;
        const body = {
            permitTypeId: caseData.permitTypeId,
            regionId: caseData.region,
            cityId: caseData.city,
            objectName: caseData.objectName || "",
            cadastralCode: caseData.cadastralCode || "",
            address: caseData.address || "",
            finished: false,
            requestedSpeedUp: false,
            acceleration: false,
            permitTypePriceId: 0,
            councilId: caseData.council,
            populatedAreaId: caseData.populatedArea,
            councilRejected: caseData.councilRejected,
            populatedAreaRejected: caseData.populatedAreaRejected,
            regionRejected: caseData.regionRejected,
            cityRejected: caseData.cityRejected,
            parentId: caseId,
            caseParentId: caseData.id,
            settingEndpointKeyWord: 'AddNewCase',
            ipAddress: "123",
            sckipCheck: true,
            request: caseData.request,
        };

        const response = await axios.post(apiUrl, body);
        if (response.data.success && response.data.resultId !== undefined) {
            const body = {
                parentCaseId: caseId,
                childCaseId: response.data.resultId
            };

            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CopyCase`, body);

            const caseStatusBody = {
                caseId: parseInt(response.data.resultId, 10),
                caseStatus: CaseStatus.CaseCreatedWithFiles.id,
                finished: false
            };

            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseStatusByUser`, caseStatusBody);
            await sendNotification(parseInt(response.data.resultId, 10));

            const fileBase64 = await toBase64(file);

            const fileData = {
                caseID: response.data.resultId,
                name: "ობიეტზე განხორციელებული ცვლილების შესახებ განცხადება",
                ext: file.name.split('.').pop(),
                file: fileBase64,
                mainInfo: "",
                additionalInfo: "",
                shared: true,
                blank: false,
                changeDocumentStatus: 1,
                documentType: 0,
                internal: CaseFilesInternal.No,
                status: CaseFilesStatus.Sent,
                decline: CaseFileDeclined.No,
                declinedInternalStatus: 0
            };

            try {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, fileData);
                window.open(`/dashboard/mycases/casemanager?id=${response.data.resultId}`, '_blank');
            } catch (error) {
            }

            closeConfirmModal();
            handleClose();
            onFileAdded();
        }
    };

    const openConfirmModal = () => {
        setIsConfirmOpen(true);
    };

    const closeConfirmModal = () => {
        setIsConfirmOpen(false);
    };

    return (
        <>
            <Dialog style={{ zIndex: 4 }} open={open} onClose={handleClose}>
                <div style={{ paddingLeft: "22px", paddingRight: "22px", marginBottom: "20px" }}>
                    <DialogTitle>ობიეტზე განხორციელებული ცვლილების შესახებ განცხადება</DialogTitle>
                    <Button variant="contained" onClick={() => fileInputRef.current.click()} className="upload-single-button">
                        აირჩიეთ ფაილი
                    </Button>
                </div>
                <input
                    type="file"
                    accept=".pdf"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />
                {file && (
                    <div className="upload-single-selected-file">
                        <div>{file.name}</div>
                        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                            <Button
                                variant="outlined"
                                onClick={handleViewDocument}
                                startIcon={<IoDocument />}
                            >
                                ნახვა
                            </Button>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={handleDeleteFile}
                                startIcon={<MdDeleteForever />}
                            >
                                წაშლა
                            </Button>
                        </div>
                    </div>
                )}

                <DialogActions>
                    <Button onClick={handleClose}>გაუქმება</Button>
                    <Button onClick={openConfirmModal} color="primary" disabled={!file}>
                        გაგზავნა
                    </Button>
                </DialogActions>
            </Dialog>
            <ConfirmationModal
                isOpen={isConfirmOpen}
                onRequestClose={closeConfirmModal}
                onConfirm={handleSendData}
            />
        </>
    );
}

export default ChildrenCaseRegistration;
